'use client';

import { useSuspenseQuery } from '@apollo/client/react';
import { FC, PropsWithChildren, useContext } from 'react';

import { GET_ALL_FINAL_PRICES } from '@/.graphql';
import { GetAllFinalPricesQuery } from '@/.gql/graphql';
import { createCustomContext } from './context';
import { useProfileContext } from './ProfileProvider';
import { AnimatedLogoFallback } from '../components/AnimatedLogoFallback';

export interface FinalPrice {
  batchSize: number;
  price: number;
  isFree: boolean;
  promoName?: string;
  promoId?: string;
  serviceType: 'image' | 'video' | 'audio';
  specificService: string;
}

const [Context, usePricesContext] = createCustomContext<FinalPrice[]>({
  name: 'PricesContext',
  strict: false,
});

export { usePricesContext };

export const PricesProvider: FC<PropsWithChildren> = ({ children }) => {
  const profile = useProfileContext();
  const { data } =
    useSuspenseQuery<GetAllFinalPricesQuery>(GET_ALL_FINAL_PRICES);
  const prices = (data?.getAllFinalPrices as FinalPrice[]) || [];

  if (!profile) {
    return <AnimatedLogoFallback />;
  }

  return <Context value={prices}>{children}</Context>;
};
